import React from 'react';

import Authorization       from 'routing/Authorization';
import GeneralLayout       from 'GeneralLayout';
import Grid                from '@mui/material/Grid';
import { Outlet as Pages } from 'react-router-dom';
import Spinner             from 'GeneralLayout/Spinner';


function RootRoute() {

  const suspenseFallback =
          <Grid container justifyContent='center'>
            <Grid item>
              <Spinner/>
            </Grid>
          </Grid>

  return (
    <GeneralLayout>
      <Authorization>
        <React.Suspense fallback={suspenseFallback}>
          <Pages/>
        </React.Suspense>
      </Authorization>
    </GeneralLayout>
  );
}

export default RootRoute;